import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { useAxios } from '@/contexts/AxiosProvider'
import { useHallUsers } from '@/contexts/HallUsersProvider'
import { Evidence } from '@db8/shared'

export const EvidenceContentModal = ({
  selectedEvidence,
  setSelectedEvidence,
  setEditingEvidence,
  selectedTab,
  onDelete = (newEvidence: Evidence) => {},
}) => {
  const axios = useAxios()
  const { currentUser } = useHallUsers()

  const deleteCard = async (e) => {
    e.stopPropagation()
    try {
      const { data } = await axios.delete(`/evidence/${selectedEvidence.id}`)
      onDelete({ ...data, toDelete: true })
      setSelectedEvidence(null)
    } catch (error) {
    }
  }

  return (
    <Dialog
      open={Boolean(selectedEvidence)}
      onOpenChange={(open) => {
        if (!open) setSelectedEvidence(null)
      }}
    >
      <DialogContent
        size="md"
        className="dark:text-white max-h-[80vh] min-h-[500px] md:min-w-[600px] w-full max-w-2xl flex flex-col"
      >
        <DialogTitle className="text-2xl font-bold mb-2">{selectedEvidence.title}</DialogTitle>

        {selectedEvidence.link && (
          <div className="mb-4 text-sm text-blue-500 overflow-hidden whitespace-nowrap text-ellipsis">
            <a
              href={selectedEvidence.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline break-all block"
            >
              Source: {selectedEvidence.link}
            </a>
          </div>
        )}

        <div className="overflow-y-auto text-sm leading-relaxed mb-4 whitespace-pre-line">
          {selectedEvidence.content}
        </div>

        {selectedTab === currentUser.speakingRole && (
          <div className="flex mt-auto justify-between gap-6">
            <Button variant="destructive" title="Remove Page" onClick={deleteCard}>
              Delete
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setEditingEvidence(selectedEvidence)
                setSelectedEvidence(null)
              }}
            >
              Edit
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
